import { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
    Dialog, DialogTitle, DialogContent, IconButton, CircularProgress, Box
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useSnackbar } from '@contexts/SnackbarContext';
import API from '@utils/axios';
import { formError } from '@utils/helpers';
import PackForm from '@components/pack/PackForm';

function PackCreationDialog({ modalCreateOpen, setModalCreateOpen, customerId, type, onSuccess }) {
    const { t } = useTranslation();
    const { showMessage } = useSnackbar();
    const form = useRef();
    const [formData] = useState({
        quantity: 0,
    });
    const [processing, setProcessing] = useState(false);

    const handleClose = () => {
        setModalCreateOpen(false);
    }

    const handleSubmit = async (data) => {
        try {
            setProcessing(true);
            data.type = type;
            await API.post(`/customers/${customerId}/packs`, data);
            showMessage(t('Credits added successfully'), 'success');
            setProcessing(false);
            setModalCreateOpen(false);
            if (onSuccess) {
                onSuccess();
            }
        } catch (error) {
            formError(error, t, form.current.setError, showMessage);
            setProcessing(false);
        }
    };

    return (
        <Dialog
            open={modalCreateOpen}
            onClose={handleClose}
            aria-labelledby="parent-modal-title"
        >
            <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                {t('Add {{type}} credits', { type: t(`credit.${type}`) })}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                }}
            >
                <CloseIcon />
            </IconButton>
            <DialogContent sx={{ width: '420px' }}>
                {processing && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <CircularProgress />
                    </Box>
                )}
                <Box sx={{ display: processing ? 'none' : 'block' }}>
                    <PackForm ref={form} initialData={formData} onSubmit={handleSubmit} />
                </Box>
            </DialogContent>
        </Dialog>
    );
}

export default PackCreationDialog;